import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as en from './en.json'
import Cookies from 'js-cookie';

const lang = Cookies.get('lang')
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
    },
    lng: lang, // Default language
    fallbackLng: 'fr', // Fallback language if translation is missing
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
